import { render, staticRenderFns } from "./HomeAuthorCard.vue?vue&type=template&id=6aee70d4"
import script from "./HomeAuthorCard.vue?vue&type=script&lang=js"
export * from "./HomeAuthorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports